import { render, staticRenderFns } from "./CartButton.vue?vue&type=template&id=6b0dc00a&scoped=true&"
import script from "./CartButton.vue?vue&type=script&lang=js&"
export * from "./CartButton.vue?vue&type=script&lang=js&"
import style0 from "./CartButton.vue?vue&type=style&index=0&id=6b0dc00a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0dc00a",
  null
  
)

export default component.exports